import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../constants';
import { useContentComposer } from '../content-composer-provider';

type Props = {
  title: string;
  subTitle: string;
};

export const EmptyState = ({ title, subTitle }: Props) => {
  const { t } = useTranslation('content-composer');
  const { setActivePanel } = useContentComposer();

  return (
    <div
      className='composer-empty-state'
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        height: '100%',
        justifyContent: 'center',
        maxWidth: '200px',
        textAlign: 'center',
      }}
    >
      <Text weight='bold' color='disabled'>
        {title}
      </Text>
      <Text color='disabled'>{subTitle}</Text>
      <Button
        variant='tertiary'
        iconName='plus-small'
        css={{
          [`@media (min-width: ${COMPOSER_BREAKPOINTS.DESKTOP + 1}px)`]: {
            display: 'none',
          },
        }}
        onClick={() => setActivePanel('toolbox')}
      >
        {t('Add Element')}
      </Button>
    </div>
  );
};
